import { Button, ListBox, ListBoxItem, Popover, Select, SelectValue } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { type SDKType } from '../model';

import './HighUsageFilter.scss';

type HighUsageFilterProps = {
  onSelect: (value: SDKType) => void;
  options: [{ name: string; value: SDKType }, { name: string; value: SDKType }];
  value: SDKType;
  selectedOption: SDKType;
};

export function HighUsageFilter({ onSelect, options, selectedOption }: HighUsageFilterProps) {
  const handleSelectionChange = (key: string | number | null) => {
    if (key) {
      onSelect(key as SDKType);
    }
  };

  return (
    <div className="high-usage-filter">
      <Select
        value={selectedOption}
        onChange={handleSelectionChange}
        className="high-usage-filter__select"
        aria-label="Filter by connection type"
      >
        <Button>
          <Icon name="data" slot="start-icon" />
          <SelectValue />
          <Icon name="chevron-down" slot="end-icon" />
        </Button>
        <Popover>
          <ListBox>
            {options.map((option) => (
              <ListBoxItem key={option.value} id={option.value} textValue={option.name}>
                {option.name}
              </ListBoxItem>
            ))}
          </ListBox>
        </Popover>
      </Select>
    </div>
  );
}
